import { AppRegistry } from 'react-native'

import App from './basePages/App'
import { name as appName } from './app.json'
import './i18n.config'
import './web/registerFonts'

AppRegistry.registerComponent(appName, () => App)
AppRegistry.runApplication(appName, {
  rootTag: document.getElementById('root'),
})
